import clsx from 'clsx'
import React from 'react'

// !mt-6 !mt-4 !mt-2
export const Title = ({ data }: { data: any }) => {
  return (
    <h2
      className={clsx(
        'text-center tracking-[-1px] font-bold',
        {
          'text-[30px] leading-[1.3] mt-12 ': data.isSmall,
          'text-[40px] leading-[1.2] mt-12 [&:nth-child(2)]:mt-6 ': !data.isSmall,
          'mt-6 ': data.version === 'alternative',
        },
        data?.classes,
      )}
      dangerouslySetInnerHTML={{ __html: data.title }}
    ></h2>
  )
}
